import React from 'react';
import { Music, Star, Calendar } from 'lucide-react';
import { formatEventDay } from '../utils/formatEventDay';

const EventCard = ({ event, onClick }) => {
  const isInactive = event.inactive;
  const points = Math.floor(event.price * 10);
  const city = event.location ? event.location.split(',')[0].trim() : '';
  const shadow = '0 2px 8px rgba(0,0,0,0.85), 0 1px 2px rgba(0,0,0,0.9)';

  return (
    <div
      className={`relative min-w-[280px] max-w-[280px] h-[320px] rounded-2xl overflow-hidden bg-black transition-transform duration-200 ${
        isInactive ? 'opacity-80' : 'cursor-pointer hover:scale-[1.02] active:scale-[0.98]'
      }`}
      onClick={() => !isInactive && onClick(event)}
      data-testid={`event-card-${event.id}`}
    >
      {/* Full flyer fills the card */}
      <img
        src={event.image}
        alt={event.name}
        className={`absolute inset-0 w-full h-full object-cover ${isInactive ? 'blur-[3px] scale-105' : ''}`}
      />
      {/* Bottom darken gradient so text is always readable */}
      <div className="absolute inset-x-0 bottom-0 h-[45%] bg-gradient-to-t from-black via-black/80 to-transparent pointer-events-none" />

      {isInactive && (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
          <span className="text-white font-bold text-lg text-center px-4" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif' }}>
            Vuelve en septiembre
          </span>
        </div>
      )}

      {/* Top-right date pill */}
      {!isInactive && event.day && (
        <div className="absolute top-3 right-3 glass-dark rounded-full px-3 py-1 flex items-center gap-1.5 text-[#F82C47] text-xs font-semibold">
          <Calendar size={12} className="text-[#F82C47]" />
          <span>{formatEventDay(event.day)}</span>
        </div>
      )}

      {/* Bottom text overlay — no card, just text on the fade */}
      {!isInactive && (
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-white font-bold text-base leading-tight truncate" style={{ textShadow: shadow }}>{event.name}</h3>
          <div className="flex items-center gap-1.5 text-gray-300 text-xs mt-0.5" style={{ textShadow: shadow }}>
            <Music size={11} className="text-gray-300" />
            <span className="truncate">
              {event.venue}
              {city && <span className="text-gray-400"> · {city}</span>}
            </span>
          </div>
          <div className="flex items-center justify-between mt-2">
            <span className="text-white font-bold text-lg whitespace-nowrap tabular-nums" translate="no" style={{ textShadow: shadow, textDecoration: 'none', WebkitTextDecorationLine: 'none', textDecorationLine: 'none', fontVariantNumeric: 'tabular-nums', fontFeatureSettings: '"tnum" 1, "zero" 0, "ss01" 0, "ss02" 0' }}>{`${event.price.toFixed(2)}€`}</span>
            <div className="glass-dark flex items-center gap-1 rounded-full px-2.5 py-1">
              <Star size={12} className="text-[#F82C47] fill-[#F82C47]" />
              <span className="text-[#F82C47] text-xs font-semibold">+{points}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventCard;
